/* Moushe Luxe \u2014 lightweight UI (no dependencies) */
(function () {
  'use strict';
  var d = document, w = window;
  var reduceMotion = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function lock(on) { d.body.classList.toggle('mh-lock', !!on); }
  function money(cents) {
    try {
      var fmt = (w.theme && w.theme.moneyFormat) || w.mhMoneyFormat || 'Rs.{{amount}}';
      var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
    } catch (e) { return cents; }
  }

  /* ---------- Announcement ---------- */
  function initAnnounce(root) {
    var items = $$('.mh-announce__item', root);
    if (items.length < 2 || root.dataset.ready) return;
    root.dataset.ready = '1';
    var i = 0, speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;
    setInterval(function () {
      if (d.hidden) return;
      var cur = items[i];
      cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 650);
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  }

  /* ---------- Header ---------- */
  function initHeader(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var header = $('.mh-header', root);
    var onScroll = function () { header && header.classList.toggle('is-scrolled', w.scrollY > 10); };
    w.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    // Drawer
    var drawer = $('[data-mh-drawer]', root);
    function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); lock(true); var c = $('[data-mh-drawer-close]', drawer); c && c.focus({ preventScroll: true }); }
    function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); lock(false); }
    $$('[data-mh-drawer-open]', root).forEach(function (b) { b.addEventListener('click', openDrawer); });
    drawer && $$('[data-mh-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });

    // Search
    var search = $('[data-mh-search]', root);
    var input = search && $('input[name="q"]', search);
    var results = search && $('[data-mh-search-results]', search);
    var suggest = search && $('[data-mh-search-suggest]', search);
    var timer, controller;
    function openSearch() { if (!search) return; search.classList.add('is-open'); search.setAttribute('aria-hidden', 'false'); lock(true); setTimeout(function () { input && input.focus(); }, 60); }
    function closeSearch() { if (!search) return; search.classList.remove('is-open'); search.setAttribute('aria-hidden', 'true'); lock(false); }
    $$('[data-mh-search-open]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
    search && $$('[data-mh-search-close]', search).forEach(function (b) { b.addEventListener('click', closeSearch); });
    if (input && results) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; suggest && (suggest.hidden = false); return; }
        timer = setTimeout(function () {
          if (controller) controller.abort();
          controller = 'AbortController' in w ? new AbortController() : null;
          var url = (w.Shopify && w.Shopify.routes ? w.Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
          fetch(url, controller ? { signal: controller.signal } : {}).then(function (r) { return r.json(); }).then(function (data) {
            var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            suggest && (suggest.hidden = true);
            if (!items.length) {
              results.innerHTML = '<p class="mh-search__label">' + (search.dataset.empty || 'No results') + '</p>';
              return;
            }
            var html = '<p class="mh-search__label">' + (search.dataset.productsLabel || 'Products') + '</p><div class="mh-search__results">';
            items.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=360';
              var price = p.price ? (String(p.price).indexOf('.') > -1 ? money(Math.round(parseFloat(p.price) * 100)) : money(p.price)) : '';
              html += '<a class="mh-search__result" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="360" height="450">' : '') +
                '<span>' + p.title.replace(/</g, '&lt;') + '</span><small>' + price + '</small></a>';
            });
            html += '</div><div class="mh-search__all"><a class="mh-btn mh-btn--outline" href="' + (w.Shopify && w.Shopify.routes ? w.Shopify.routes.root : '/') + 'search?q=' + encodeURIComponent(q) + '&type=product">' + (search.dataset.viewAll || 'View all results') + '</a></div>';
            results.innerHTML = html;
          }).catch(function () {});
        }, 220);
      });
    }

    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeSearch(); } });

    // Cart count (Ella updates [data-cart-count] after AJAX add)
    $$('[data-mh-cart-count]', root).forEach(function (el) {
      var sync = function () { el.classList.toggle('is-empty', !parseInt(el.textContent, 10)); };
      sync();
      if ('MutationObserver' in w) new MutationObserver(sync).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    if (root.dataset.ready) return;
    var slides = $$('.mh-hero__slide', root);
    if (slides.length < 2) return;
    root.dataset.ready = '1';
    var dots = $$('.mh-hero__dot', root);
    var i = 0, timer = null, speed = (parseInt(root.dataset.speed, 10) || 6) * 1000, auto = root.dataset.autoplay === 'true';
    root.style.setProperty('--mh-speed', speed / 1000 + 's');
    function go(n) {
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
      dots[i] && (dots[i].classList.remove('is-active'), dots[i].setAttribute('aria-current', 'false'));
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden', 'false');
      if (dots[i]) { dots[i].classList.remove('is-active'); void dots[i].offsetWidth; dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
      $$('img[loading="lazy"]', slides[i]).forEach(function (img) { img.loading = 'eager'; });
      restart();
    }
    function restart() { clearTimeout(timer); if (auto && !reduceMotion && !root.classList.contains('is-paused')) timer = setTimeout(function () { go(i + 1); }, speed); }
    dots.forEach(function (dot, n) { dot.addEventListener('click', function () { go(n); }); });
    var prev = $('.mh-hero__arrow--prev', root), next = $('.mh-hero__arrow--next', root);
    prev && prev.addEventListener('click', function () { go(i - 1); });
    next && next.addEventListener('click', function () { go(i + 1); });
    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); restart(); });
    var sx = 0, sy = 0;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    d.addEventListener('visibilitychange', function () { d.hidden ? clearTimeout(timer) : restart(); });
    restart();
  }

  /* ---------- Scrollers (progress + arrows) ---------- */
  function initScroller(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var wrap = el.closest('[data-mh-scroll-wrap]') || el.parentNode;
    var bar = $('[data-mh-progress] span', wrap);
    function update() {
      if (!bar) return;
      var max = el.scrollWidth - el.clientWidth;
      var ratio = el.clientWidth / el.scrollWidth;
      bar.parentNode.style.visibility = max <= 2 ? 'hidden' : 'visible';
      bar.style.width = Math.max(ratio * 100, 12) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (el.scrollLeft / max) * ((1 / Math.max(ratio, .12)) - 1) * 100 : 0) + '%)';
    }
    el.addEventListener('scroll', update, { passive: true });
    w.addEventListener('resize', update);
    update();
    $$('[data-mh-prev],[data-mh-next]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = el.firstElementChild; var step = card ? card.getBoundingClientRect().width + 24 : el.clientWidth;
        el.scrollBy({ left: btn.hasAttribute('data-mh-prev') ? -step : step, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var tabs = $$('[role="tab"]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on);
          var p = d.getElementById(t.getAttribute('aria-controls')); if (p) { p.hidden = !on; if (on) $$('[data-mh-scroller]', p).forEach(function (s) { s.dispatchEvent(new Event('scroll')); }); }
        });
      });
    });
  }

  /* ---------- Modals ---------- */
  d.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mh-modal-open]');
    if (opener) {
      var m = d.getElementById(opener.getAttribute('data-mh-modal-open'));
      if (m) { e.preventDefault(); if (m.parentNode !== d.body) d.body.appendChild(m); m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); lock(true); var c = $('[data-mh-modal-close]', m); c && c.focus({ preventScroll: true }); }
      return;
    }
    var closer = e.target.closest('[data-mh-modal-close]');
    if (closer) { var mm = closer.closest('.mh-modal'); if (mm) { mm.classList.remove('is-open'); mm.setAttribute('aria-hidden', 'true'); lock(false); } }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.mh-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); lock(false); });
  });

  /* ---------- Reveal on scroll ---------- */
  var io = ('IntersectionObserver' in w) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;
  function initReveal(scope) {
    $$('.mh-reveal:not(.is-in)', scope).forEach(function (el, n) {
      if (!io) { el.classList.add('is-in'); return; }
      el.style.transitionDelay = Math.min(n % 6, 5) * 70 + 'ms';
      io.observe(el);
    });
  }

  function init(scope) {
    scope = scope || d;
    $$('[data-mh-announce]', scope).forEach(initAnnounce);
    $$('[data-mh-header]', scope).forEach(initHeader);
    $$('[data-mh-hero]', scope).forEach(initHero);
    $$('[data-mh-scroller]', scope).forEach(initScroller);
    $$('[data-mh-tabs]', scope).forEach(initTabs);
    initReveal(scope);
  }

  w.mhInit = init;
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
